import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import CheckoutStepFormContext from "../CheckoutStepFormContext";
import Green_Outline_Btn from "../../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import { Form } from "react-bootstrap";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  AllCity,
  allGoogleLocations,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrderAddress,
  EditOrderAddress,
  getAllOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";
import { Next } from "react-bootstrap/esm/PageItem";
import { deleteUserAddress } from "../../../../features/user/userSlice";
import Light_Gray_Outline_Btn from "../../../common-components/common_btn/gray_outline_btn/Light_Gray_Outline_Btn";
import { Navigate, useNavigate } from "react-router-dom";
import { logDOM } from "@testing-library/react";

const countryOptions = [
  { value: "in", label: "India" },
  { value: "us", label: "United States" },
];

const stateOptions = [
  { value: "maharashtra", label: "Maharashtra" },
  { value: "karnataka", label: "Karnataka" },
];

const Details = ({ selectedAddressId, setSelectedAddressId }) => {
  const { details, setDetails, next } = useContext(CheckoutStepFormContext);
  const [showTextarea, setShowTextarea] = useState(false);

  const {
    control,
    handleSubmit,
    register,
    getValues,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      // name: details.name || "",
      // pincode: details.pincode || "",
      // addressLine1: details.addressLine1 || "",
      // addressLine2: details.addressLine2 || "",
      // landmark: details.landmark || "",
      // city: details.city || "",
      // country: details.country || null,
      // state: details.state || null,
      // defaultAddress: details.defaultAddress || false,
      // instructions: details.instructions || "",
      // contact: details.contact || "",
    },
  });

  const current_location = useSelector(
    (state) => state.location.current_location,
  );

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const handleCountryChange = (selectedOption) => {
    setValue("country_id", selectedOption?.value);
    setValue("state_id", null);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllState({ countryId: selectedOption.value }));
  };

  const handleStateChange = (selectedOption) => {
    setValue("state_id", selectedOption.value);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllCity({ stateId: selectedOption.value }));
  };

  const handleCityChange = (selectedOption) => {
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    setValue("pincode_id", selectedOption?.value);
  };

  const onSubmit = async (data) => {
    setAddressError("");
    const DataToSend = new FormData();
    DataToSend.append("lat", data?.lat);
    DataToSend.append("long", data?.long);
    DataToSend.append("country_id", data?.country_id);
    DataToSend.append("state_id", data?.state_id);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.apartment);
    DataToSend.append("direction", data?.direction);
    const res = await dispatch(createOrderAddress({ data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      setIsEdit(false);
      reset();
      await setSelectedAddressId(res.payload?.data?.id);
      await dispatch(getAllOrderAddress());

      next();
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const handleUpdate = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("lat", data?.lat);
    DataToSend.append("long", data?.long);
    DataToSend.append("country_id", data?.country_id);
    DataToSend.append("state_id", data?.state_id);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.apartment);
    DataToSend.append("direction", data?.direction);
    const res = await dispatch(EditOrderAddress({ id, data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(getAllOrderAddress());
    } else if (res.meta?.requestStatus === "rejected") {
    }
    setIsEdit(false);
    reset();
  };
  const [isEdit, setIsEdit] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const allAddress = useSelector((state) => state.order.allOrdersAddress);

  useEffect(() => {
    dispatch(getAllOrderAddress());
    if (allAddress?.data?.length > 0) {
      setSelectedAddressId(allAddress.data[0].id);
    }
  }, [dispatch]);

  const handleDelete = async (id) => {
    await dispatch(deleteUserAddress(id));
    await dispatch(getAllOrderAddress());
  };

  const [id, setId] = useState();

  const handleEdit = async (data) => {
    const res = await dispatch(getSingleOrderAddress({ id: data.id }));

    const address = res?.payload?.data;

    setId(data.id);
    setIsUpdate(true);
    setIsEdit(true);

    // dispatch(AllState({ countryId: address.country_id }));
    // dispatch(AllCity({ stateId: address.state_id }));
    // dispatch(AllPincode({ cityId: address.city_id }));

    reset(address);
  };

  const handleAdd = () => {
    setIsUpdate(false);
    setId(null);

    reset({
      country_id: null,
      state_id: null,
      city_id: null,
      pincode_id: null,
      name: "",
      building: "",
      apartment: "",
      direction: "",
      contact_no: "",
    });

    setIsEdit(true);
    setAddressError("");
  };
  const handleCancel = async () => {
    await dispatch(getAllOrderAddress());
    setIsEdit(false);
  };

  const [addressError, setAddressError] = useState("");

  const handleNext = () => {
    if (allAddress?.data?.length > 0) {
      setAddressError(""); // Clear error
      next(); // Proceed
    } else {
      setAddressError("Please add an address before continuing.");
    }
  };

  useEffect(() => {
    if (selectedAddressId) {
      setSelectedAddressId(selectedAddressId);
    } else if (allAddress?.data?.length > 0) {
      setSelectedAddressId(allAddress.data[0].id);
    }
  }, [allAddress?.data]);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isUpdate && current_location?.formatted_address) {
      setValue("street", current_location.formatted_address, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [current_location, setValue]);

  const allplaces = useSelector((state) => state.master.places);

  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search && search.trim().length >= 2) {
        dispatch(allGoogleLocations(search));
        setShowDropdown(true);
      } else {
        setShowDropdown(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [search, dispatch]);

  return (
    <>
      <div className="add_address_radio_box">
        <h4>Your Saved Address</h4>

        <div className="row">
          {allAddress?.data?.map((val, index) => {
            const parts = [
              val?.building,
              val?.street,
              val?.apartment,
              val?.Users_Address_Detail?.Country?.name,
              val?.Users_Address_Detail?.State?.name,
              val?.Users_Address_Detail?.City?.name,
              val?.Users_Address_Detail?.Pincode?.name,
            ];
            const fullAddress = parts.filter(Boolean).join(", ");

            return (
              <div
                className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-2"
                key={val.id || index}
              >
                <div className="address_radio_box_holder">
                  <Form.Check
                    inline
                    label={fullAddress}
                    name="group1"
                    type="radio"
                    value={val?.id}
                    checked={selectedAddressId === val.id}
                    onChange={() => setSelectedAddressId(val.id)}
                  />

                  <div className="icons_holder">
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="edit_icon"
                        onClick={() => {
                          handleEdit(val);
                        }}
                      />
                    </div>
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="delete_icon"
                        onClick={() => {
                          handleDelete(val.id);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          {/* <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 mb-2">
            <div className="address_radio_box_holder">
              <Form.Check
                inline
                label="Flat No. 502, Orchid Towers Koregaon Park Road Pune, Maharashtra 411001 India"
                name="group1"
                type="radio"
              />
            </div>
          </div> */}
        </div>

        <div className="form_footer">
          <p className="add_address_text" onClick={handleAdd}>
            Add Address
          </p>
        </div>
      </div>
      {isEdit && (
        <>
          <Form className="details__wrapper">
            <div className="row">
              <div className="col-12">
                <Form.Group
                  className={`form__item input_group ${
                    errors.name ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    placeholder="Enter Full Name"
                    {...register("name", {
                      required: "Full name is required",
                    })}
                  />
                  {errors.name && (
                    <p className="error__feedback">{errors.name.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group
                  className={`form__item input_group ${
                    errors.name ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Address *</Form.Label>
                  <Form.Control
                    placeholder="Enter Area"
                    value={search}
                    {...register("building", {
                      required: "Area is required",
                    })}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearch(value);
                      setValue("building", value, {
                        shouldValidate: true,
                      });
                    }}
                  />
                  {errors.name && (
                    <p className="error__feedback">{errors.name.message}</p>
                  )}

                  {showDropdown && allplaces?.length > 0 && (
                    <div
                      className="position-absolute bg-white border rounded shadow w-100"
                      style={{
                        zIndex: 1000,
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}
                    >
                      {allplaces.map((place) => (
                        <div
                          key={place.place_id}
                          className="p-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSearch(place.description);
                            setValue("building", place.address, {
                              shouldValidate: true,
                            });

                            // Optional: fill other fields
                            setValue("city_id", place.city);
                            setValue("state_id", place.state);
                            setValue("country_id", place.country);
                            setValue("pincode_id", place.pincode);
                            setValue("lat", place.location.lat);
                            setValue("long", place.location.lng);

                            setShowDropdown(false);
                          }}
                        >
                          {place.address}
                        </div>
                      ))}
                    </div>
                  )}
                </Form.Group>
              </div>

              <div className="col-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.country ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Country / Region *</Form.Label>
                  <Form.Control
                    {...register("country_id", {
                      required: "Country is required",
                    })}
                    placeholder="Country"
                  />
                  {errors.country_id && (
                    <p className="error__feedback">
                      {errors.country_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.state ? "input__error" : ""
                  }`}
                >
                  <Form.Label>State *</Form.Label>
                  <Form.Control
                    {...register("state_id", {
                      required: "State is required",
                    })}
                    placeholder="State"
                  />
                  {errors.state_id && (
                    <p className="error__feedback">{errors.state_id.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.city ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Town / City *</Form.Label>
                  <Form.Control
                    {...register("city_id", {
                      required: "City is required",
                    })}
                    placeholder="City"
                  />
                  {errors.city_id && (
                    <p className="error__feedback">{errors.city_id.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className={`form__item input_group ${
                    errors.pincode ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Pincode *</Form.Label>
                  <Form.Control
                    {...register("pincode_id", {
                      required: "Pincode is required",
                    })}
                    placeholder="Pincode"
                  />
                  {errors.pincode_id && (
                    <p className="error__feedback">
                      {errors.pincode_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form__item input_group">
                  <Form.Label>Contact *</Form.Label>
                  <Controller
                    name="contact_no"
                    control={control}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault(); // Block non-numeric input
                      }
                    }}
                    rules={{
                      required: "Contact is required",

                      minLength: {
                        value: 12,
                        message: "Mobile number must be 10 digits",
                      },
                      maxLength: {
                        value: 12,
                        message: "Mobile number must be 10 digits",
                      },
                      pattern: {
                        value: /^[6-9]\d{11}$/,
                        message: "Enter valid 10-digit contact number",
                      },
                    }}
                    onChange={(e) => {
                      setValue("contact_no", e.target.value);
                      clearErrors("contact_no");
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        {...field}
                        country="in"
                        onChange={(value) => field.onChange(value)}
                        inputClass="form-control"
                      />
                    )}
                  />
                  {errors.contact_no && (
                    <p className="error__feedback">
                      {errors.contact_no.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Group
                  className={`form__item input_group ${
                    errors.addressLine1 ? "input__error" : ""
                  }`}
                >
                  <Form.Label>Apartment *</Form.Label>
                  <Form.Control
                    type="text"
                    name="apartment"
                    placeholder="Enter Address"
                    {...register("apartment")}
                    onChange={(e) => {
                      setValue("apartment", e.target.value);
                      clearErrors("apartment");
                    }}
                  />
                  {errors.apartment && (
                    <p className="error__feedback">
                      {errors.apartment.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              <div className="col-12">
                <Form.Group className="form__item input_group">
                  <Form.Label>Landmark</Form.Label>
                  <Form.Control
                    type="text"
                    name="direction"
                    placeholder="Enter Address"
                    {...register("direction")}
                    onChange={(e) => {
                      setValue("direction", e.target.value);
                      clearErrors("direction");
                    }}
                  />
                </Form.Group>
              </div>
            </div>

            <div className="form__item button__items d-flex justify-content-center">
              {isUpdate ? (
                <Green_Outline_Btn
                  btnText="Update"
                  onClick={handleSubmit(handleUpdate)}
                />
              ) : (
                <Green_Outline_Btn
                  btnText="Save & Next"
                  // btnText="Save & Next"
                  onClick={handleSubmit(onSubmit)}
                />
              )}
              <Green_Outline_Btn
                // btnText="Next"
                btnText="Cancel"
                onClick={() => handleCancel()}
                // onClick={() => next()}
              />
            </div>
          </Form>
        </>
      )}
      {!isEdit && (
        <div className="form__item button__items d-flex justify-content-center align-items-center mb-3">
          <Green_Outline_Btn
            btnText="Back"
            onClick={() => navigate("/product-cart")}
          />
          <Green_Outline_Btn btnText="Next" onClick={handleNext} />
          {addressError && <p className="text-danger mt-2">{addressError}</p>}
        </div>
      )}
    </>
  );
};

export default Details;
